import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { CustomerTreeService } from '../api/customer-tree/customer-tree.service';
import { CustomerTree } from '../api/customer-tree/customer-tree.model';
import { CanDeactivateGuard } from '../../../app/can-deactivate.guard';
import { MatSelect } from '@angular/material';

@Component({
	selector: 'subheader',
	templateUrl: './subheader.component.html',
	styleUrls: ['./subheader.component.scss']
})
export class SubheaderComponent implements OnInit {

	readonly SELECT_LEVEL_NAME: string = '...';

	@Input('selectedLevelId') inputLevelId: number = 0;
	@Output('selectionChange') selectionChange: EventEmitter<CustomerTree> = new EventEmitter();

	userHomeLevelId: number = 83;

	customerTree: CustomerTree = null;
	customerTreeForId: Map<number, CustomerTree> = new Map<number, CustomerTree>();
	selectedLevel: CustomerTree = null;

	breadcrumbLevels: CustomerTree[] = [];

	constructor(
		private customerTreeService: CustomerTreeService,
		private canDeactivateGuard: CanDeactivateGuard
	) {
		this.customerTreeService.getCustomerTree()
			.then(customerTree => {
				this.customerTree = customerTree;
				this.prepareCustomerTree(customerTree);
				if (this.customerTreeForId.has(this.inputLevelId))
					this.setSelectedLevel(this.inputLevelId);
				else if (this.customerTreeForId.has(this.userHomeLevelId))
					this.setSelectedLevel(this.userHomeLevelId);
				else
					this.setSelectedLevel(this.customerTree.id);
			});
	}

	ngOnInit() { }

	ngOnChanges() {
		if (this.customerTree && this.inputLevelId)
			this.setSelectedLevel(this.inputLevelId);
	}

	// MÃ©thode rÃ©cursive pour mapper chaque niveau de l'arborescence descendante avec son ID et ajouter un niveau de sÃ©lection Ã  chaque parent
	prepareCustomerTree(customerTree: CustomerTree) {
		this.customerTreeForId.set(customerTree.id, customerTree);
		if (customerTree.children) {
			let selectLevel = new CustomerTree();
			selectLevel.name = this.SELECT_LEVEL_NAME;
			selectLevel.parentId = customerTree.id;
			customerTree.children.push(selectLevel);
			for (let child of customerTree.children) {
				this.prepareCustomerTree(child);
			}
		}
	}

	setSelectedLevel(selectedLevelId: number) {
		this.selectedLevel = this.customerTreeForId.get(selectedLevelId);
		if (!this.selectedLevel)
			this.selectedLevel = this.customerTree;
		this.inputLevelId = this.selectedLevel.id;
		this.breadcrumbLevels = this.getBreadcrumbLevels(this.selectedLevel, []);

		let selectedLevelCopy: CustomerTree = JSON.parse(JSON.stringify(this.selectedLevel));
		selectedLevelCopy.children = selectedLevelCopy.children.filter(level => level.id);
		this.selectionChange.emit(selectedLevelCopy);
	}

	// MÃ©thode rÃ©cursive pour construire le fil d'arianne en remontant l'arborescence
	getBreadcrumbLevels(level: CustomerTree, breadcrumbLevels: CustomerTree[]): CustomerTree[] {
		if (breadcrumbLevels.length === 0 && level.children && level.children.length > 1) {
			breadcrumbLevels.unshift(level.children.find(child => !child.id));
		}

		breadcrumbLevels.unshift(level);

		let parent: CustomerTree = this.customerTreeForId.get(level.parentId);
		if (parent)
			this.getBreadcrumbLevels(parent, breadcrumbLevels);

		return breadcrumbLevels;
	}

	getBrothers(level: CustomerTree) {
		let parent: CustomerTree = this.customerTreeForId.get(level.parentId);
		if (parent) {
			return parent.children;
		} else {
			return [level];
		}
	}

	onHomeClick() {
		this.canDeactivateGuard.canDeactivate().then(canDeactivate => {
			if (canDeactivate)
				this.setSelectedLevel(this.userHomeLevelId);
		});
	}

	onOpenedChange(matSelect: MatSelect) {
		if (matSelect.panelOpen) {
			this.canDeactivateGuard.canDeactivate().then(canDeactivate => {
				if (!canDeactivate)
					matSelect.close();
			});
		}
	}

	onSelectLevel(level: CustomerTree) {
		if (level.id)
			this.setSelectedLevel(level.id);
		else
			this.setSelectedLevel(level.parentId);

	}
}
